import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  OnInit,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { FormControlComponent, PrimengButtonDirective } from '@web/shared/ui';
import { Button } from 'primeng/button';
import { valueOrDefault } from '@web/utils';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { AdminCartSettingsFormData, AdminCartSettingsFormGroup } from '../../models/admin-cart-settings-form-data';

@Component({
  selector: 'app-admin-cart-settings-form',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormControlComponent,
    Button,
    PrimengButtonDirective,
    ToggleSwitch,
  ],
  templateUrl: './admin-cart-settings-form.component.html',
  styleUrl: './admin-cart-settings-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminCartSettingsFormComponent implements OnInit {
  private readonly builder = inject(FormBuilder);

  public readonly data = input.required<AdminCartSettingsFormData>();
  public readonly submitClickEvent = output<AdminCartSettingsFormData>();

  protected readonly form = this.buildForm();

  public ngOnInit(): void {
    this.fillByData();
  }

  public handleSubmitClick(): void {
    this.submitClickEvent.emit(this.toData());
  }

  private toData(): AdminCartSettingsFormData {
    const data = this.form.getRawValue();

    return new AdminCartSettingsFormData({
      deleteCartAfterCheckout: valueOrDefault(data.deleteCartAfterCheckout, false),
    });
  }

  private buildForm(): AdminCartSettingsFormGroup {
    /* prettier-ignore */
    return this.builder.group({
      deleteCartAfterCheckout: this.builder.control<boolean | null>(null),
    });
  }

  private fillByData(): void {
    const data = this.data();

    this.form.patchValue(
      {
        deleteCartAfterCheckout: data.deleteCartAfterCheckout,
      },
      { emitEvent: false },
    );
  }
}
